import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { ViewFeedbackComponent } from './view-feedback.component';

export const viewFeedbackState: Ng2StateDeclaration = {
  name: 'app.view-feedback',
  url: '/view-feedback?token',
  data: {
    authorities: [],
  },
  views: {
    'content@': {
      component: ViewFeedbackComponent,
    },
  },
  resolve: [
    {
      token: 'token',
      deps: [Transition],
      resolveFn: (trans: Transition) => trans.params().token,
    },
  ],
};
